import PropTypes from 'prop-types';

const titleClassName =
  'font-google-basic text-lg md:text-35px text-nero uppercase leading-6 md:leading-34px text-center font-normal tracking-widest';

const SectionHeading = ({ letterSpacing = 3, subTitle, title, underline }) => (
  <div className='justify-items-center'>
    <div
      className={titleClassName}
      style={{ letterSpacing }}
    >
      {title}
    </div>
    {underline && (
      <div className='h-1 w-12 bg-divider-gradient-background rounded mt-2 mx-auto'></div>
    )}
    {subTitle && (
      <div
        className='text-nero text-sm md:text-xl leading-4 font-normal mt-1 text-center Montserrat font-normal py-2'
        style={{ letterSpacing: 2 }}
      >
        {subTitle}
      </div>
    )}
  </div>
);

SectionHeading.propTypes = {
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  underline: PropTypes.bool
};

export default SectionHeading;
